/* NGC navigation: mobile menu toggle. Without JavaScript the menu simply stays open. */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 989px)');

  function init(root) {
    root.querySelectorAll('[data-ngc-nav-toggle]').forEach(function (toggle) {
      if (toggle.__ngcNav) return;
      toggle.__ngcNav = true;

      var menu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!menu) return;

      function setOpen(open, returnFocus) {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        menu.classList.toggle('is-open', open);
        if (!open && returnFocus) toggle.focus();
      }

      toggle.addEventListener('click', function () {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });

      menu.addEventListener('click', function (event) {
        if (event.target.closest('a')) setOpen(false);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          setOpen(false, true);
        }
      });

      MQ.addEventListener('change', function () { setOpen(false); });
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
